import {Component} from 'react';
import PropTypes from 'prop-types';
import ImageGallery from 'components/ImageGallery';
import SimpleModal from 'components/SimpleModal';
import resizedDasWebUri, {presetDimensions} from 'components/imaging/ResizedDasWebImage';
import AnalyticsGateway from 'lib/AnalyticsGateway';
import 'components/ImageGalleryModal.scss';

export default class ImageGalleryModal extends Component {
  static propTypes = {
    currentIndex: PropTypes.number,
    images: PropTypes.array.isRequired,
    objectContext: PropTypes.string.isRequired,
    onIndexChange: PropTypes.func,
    pageContext: PropTypes.string.isRequired,
    resizeDimensions: PropTypes.shape({
      width: PropTypes.number,
      height: PropTypes.number,
    }),
    trigger: PropTypes.node,
  };

  static defaultProps = {
    resizeDimensions: presetDimensions.LARGE,
    images: [],
  };

  open = () => {
    const {objectContext, pageContext} = this.props;
    AnalyticsGateway.sendEvent({
      eventName: 'View Image Gallery',
      properties: [{label: 'Page', value: pageContext}, {label: 'Object Context', value: objectContext}]
    });
  };

  close = () => this.modal.close();

  render() {
    const {images, resizeDimensions, trigger, currentIndex, onIndexChange} = this.props;
    const resizedImages = images.map(uri => resizedDasWebUri({
      uri,
      resizeDimensions,
    }));
    return (
      <SimpleModal
        className="image-gallery-simple-modal"
        basic
        ref={it => this.modal = it}
        trigger={trigger}
        content={
          <ImageGallery images={resizedImages} currentIndex={currentIndex} onIndexChange={onIndexChange}/>
        }
        onOpen={this.open}
      />
    );
  }
}